export default __webpack_public_path__ + "static/media/URVETCARE_WRD_BLUE_BG.316003f4.jpg";